import { useEffect } from "react"
import { Helmet } from "react-helmet"

import { envDetails } from "@trueskin-web/core"

import "../styles/widget.css"

const HeyflowWidget = ({
  id,
  urlParameters,
  onReady,
  onQuestionChanged,
  onSubmit,
}) => {
  useEffect(() => {
    function handleOnSubmit(event) {
      onSubmit(event.detail)
    }
    function handleOnQuestionChanged(event) {
      if (!onQuestionChanged) return
      onQuestionChanged(event.detail)
    }

    window.addEventListener("heyflow-screen-view", handleOnQuestionChanged)
    window.addEventListener("heyflow-submit", handleOnSubmit)

    return () => {
      window.removeEventListener("heyflow-screen-view", handleOnQuestionChanged)
      window.removeEventListener("heyflow-submit", handleOnSubmit)
    }
  }, [onQuestionChanged, onSubmit])

  return (
    <div className={"full-screen-widget"}>
      <Helmet
        onChangeClientState={(_, { scriptTags }) => {
          if (scriptTags?.length && onReady) {
            scriptTags[0].onload = onReady
          }
        }}
      >
        <script
          defer
          src="https://static.heyflow.app/widget/latest/webview.js"
        />
      </Helmet>

      <heyflow-wrapper
        flow-id={id}
        scroll-up-on-navigation
        url-parameters={new URLSearchParams(
          Object.assign({}, urlParameters || {}, {
            api_prefix: envDetails.isProduction
              ? "/production-de" // TODO @fox: switch to using envDetails.apiPrefix once funnel and cla are moved to hit gateway.formelskin.de
              : envDetails.apiPrefix,
          })
        ).toString()}
        style-config='{"height": "100%"}'
      />
    </div>
  )
}

export default HeyflowWidget
